export default [
	{
		code: 'e',  // Summit Employee (changed from 'summit_employee')
		name: 'Summit - Employee',
	},
	{
		code: 'a',  // Summit Agent (changed from 'summit_agent')
		name: 'Summit - Agent',
	},
	{
		code: 'q',  // Peak Employee (changed from 'peak_employee')
		name: 'Peak - Employee',
	},
	{
		code: 'p',  // Peak Agent (changed from 'peak_agent')
		name: 'Peak - Agent',
	},
	// HSC role commented out - existing HSC users will be handled as legacy
	// {
	// 	code: 'h',
	// 	name: 'HSC',
	// }	
];